module.exports = __webpack_public_path__ + "img/business.dd21ff08.svg";